const ESTADOS_SUGERENCIAS = [
  {
    id: 1,
    name: 'Enviada a la IA'
  },
  {
    id: 2,
    name: 'Pendiente'
  },
  {
    id: 3,
    name: 'Aceptada'
  },
  {
    id: 4,
    name: 'Rechazada'
  },
  {
    id: 5,
    name: 'Error en llamada a IA'
  }
]

export {
  ESTADOS_SUGERENCIAS
}
